import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthService } from '../auth.service';
import { SecurityStorage } from '../storages/security.storage';

@Injectable()
export class AuthHttpInterceptor implements HttpInterceptor {
    private authService = inject(AuthService);
    private securityStorage = inject(SecurityStorage);

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.authService.isLoggedIn()) {
            const userToken = this.securityStorage.getUserInfo();
            const authRequest = request.clone({
                headers: request.headers.set('Authorization', `Bearer ${userToken.token}`)
            });

            return next.handle(authRequest);
        }

        return next.handle(request);
    }
}
